import React from 'react';
import { Crop as RoiIcon } from '@mui/icons-material';
import ProjectPageHeader from '../../../components/ProjectPageHeader';
import MapViewerLauncher from '../../../components/MapViewerLauncher';

interface RoiWorkHeaderProps {
  /** 호환을 위해 받지만 ProjectPageHeader 가 useParams 로 자체 해결한다. */
  projectId?: string;
}

/**
 * ROI 편집기 헤더.
 *
 * 우측 액션에 MapViewerLauncher 추가 — 같은 현장에 등록된 맵을 새 탭으로
 * 띄워 ROI 좌표를 정합하며 작업할 수 있다.
 */
export const RoiWorkHeader: React.FC<RoiWorkHeaderProps> = ({ projectId }) => {
  const siteId = projectId ? Number(projectId) : NaN;
  return (
    <ProjectPageHeader
      currentPageLabel="ROI 편집"
      currentPageIcon={<RoiIcon fontSize="inherit" />}
      rightExtras={
        Number.isFinite(siteId) ? <MapViewerLauncher siteProjectId={siteId} /> : null
      }
    />
  );
};
